import { FridgeOutlineIcon } from './FridgeOutlineIcon';

/**
 * author: Austin Andrews
 * id 214668FF-C50D-4D69-B916-AE66E73CB3B0
 * name fridge-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/fridge-outline.svg
 * tags
 * - Home Automation 
 */
export const RefrigeratorOutlineIcon = FridgeOutlineIcon;
export default RefrigeratorOutlineIcon